// jshint maxparams:200

// Important!
// Place all components used inside [data-result-layout] in boot-result-layout
import bootResultLayout from 'static/script/app/boot/item-result-list/boot-result-layout';
import Toggle from 'static/script/app/ui/toggle';
import ResultLayout from 'static/script/app/ui/search-result/result-layout';
import InputNumberUI from 'static/script/app/ui/input-number-ui';
import ItemsInViewportService from 'static/script/app/data/items-in-viewport-service';
import WishListService from 'static/script/app/data/wish-list-service';
import FilterModalUI from 'static/script/app/ui/search-result/filter-modal-ui'; // TODO: These file namings are embarrassing, sorry!
import ModalFilterUI from 'static/script/app/ui/search-result/modal-filter-ui'; // modal-filter and filter-modal are kinda coupled
// import Realtime from 'static/script/app/ui/realtime';
import ShopItemSettingsAction from 'static/script/app/ui/shop-item-settings-action';
import BrandSuggestionService from 'static/script/app/data/brand-suggestion-service';
import priceSlider from 'containers/price-slider';

module.exports = initData => {
    Toggle.attachTo('[data-toggle]');
    ResultLayout.attachTo('[data-result-layout]');
    ShopItemSettingsAction.attachTo('[data-card-list-container]');
    ShopItemSettingsAction.attachTo('[data-card-list-container-ondisplay]');

    if (initData.featureSwitches && initData.featureSwitches['search-metadata-collection-searchimpression']) {
        ItemsInViewportService.attachTo(document);
    }

    InputNumberUI.attachTo(document.body);
    WishListService.attachTo(document);

    FilterModalUI.attachTo('body');
    ModalFilterUI.attachTo('body');
    BrandSuggestionService.attachTo(document);
    priceSlider(document.querySelectorAll('[data-price-range]'));
    bootResultLayout(initData, false);
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/boot/boot-item-result-list.js